<label *ngIf="label" [class.required]="isRequired"> {{ label }}</label>
<div class="radio-btn-wrapper">
	<div *ngFor="let element of list; let i = index" class="radio-btn-item" [class.error]="isShowError && i === 0" [class.active]="element[0] === value" [class.disabled]="disabled"
		(click)="isChange? checkItem(element[0]): null">
		<span [class.cursor-none]="!isChange">{{element[1]}}</span>
	</div>
</div>